import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'core-js/features/array/includes';
import 'core-js/features/object/assign';
import 'core-js/features/promise';

import MainComponent from './components/MainComponent/MainComponent';

ReactDOM.render(
    <React.StrictMode>
        <MainComponent />
    </React.StrictMode>,
    document.getElementById('root')
);
